export const orbitIcons = {
    "refresh_draw": 'assets/icon/refresh_draw.svg',  // "../../../assets/icon/refresh_draw.svg"
    "marker_v1": 'assets/icon/marker_v1.svg',
    "marker_v2": 'assets/icon/marker_v2.svg',
    "marker_v3": 'assets/icon/marker_v3.svg',
    "not_found_1": "assets/images/not_found_image_1.svg",
    "tabs_map": 'assets/icon/tabs_map.svg',
    "tabs_farm": 'assets/icon/tabs_farm.svg',
    "tabs_explore": 'assets/icon/tabs_explore.svg',
    "tabs_user": 'assets/icon/tabs_user.svg',
    "tabs_compare": 'assets/icon/tabs_compare.svg',
    "filter": 'assets/icon/filter.svg',
    "cloud_moon": 'assets/icon/cloud_moon.svg',
    "lock": 'assets/icon/lock.svg',
    "delete_v1": "assets/images/delete_icon_v1.svg",
    "draw_farm": "assets/icon/polygon.svg",
    "parcel_inquiry": "assets/icon/search.svg",
    "saved_list": "assets/icon/bookmark.svg"
}